<template>
  <div>
      <div >
        <mt-field class='mgtop10 after' :state="state.username" v-model="data.username" :attr="{ 'maxlength': 20 }" label="手机号"></mt-field>
        <mt-field class='after' label="密码" :attr="{ 'maxlength': 20 }" :state="state.password" v-model="data.password" :type="mytype" placeholder="不能少于6位">
          <mt-switch v-model="switchValue"></mt-switch>
        </mt-field>
        <mt-field class='after' :attr="{'maxlength': 6 }" :state="state.verifyCode" v-model="data.verifyCode" label="短信验证码">
          <mt-button height="45px" width="100px" :disabled="smsCount>0"  @click="sendSmsForReg" type="default">{{smsLabel}}</mt-button>
        </mt-field>
      </div>
    <div class="padlr10">
      <mt-button size="large" type="primary" @click="register()">注册</mt-button>
    </div>
    <div class="padlr10 clear">
      <router-link class='left' to="/login/xieyi">使用协议</router-link>
      <router-link class='right' to="/login/login">登录</router-link>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui';
  var InterValObj;
  let attrs = [{name:'username',reg:/^1[23456789]\d{9}$/},
    {name:'password',reg:/.{6,}/},
    {name:'verifyCode',reg:/.{6}/}];
  export default {
    name: "login",
    data() {
      return {
        switchValue: true
        ,smsCount:0
        ,data:{}
        ,state:{username:'',password:'',verifyCode:''}
      }
    },
    computed: {
      //计算属性
      mytype: function () {
        return this.switchValue ? 'password' : ''
      },
      smsLabel:function(){
         return this.smsCount ==0?"发送验证码":this.smsCount+"秒再获取";
      }
    },
    watch:{data:{
        handler(newVal,oldVal){
          attrs.forEach(n=>{
            if(newVal[n.name]==undefined||newVal[n.name]==''){
              this.state[n.name] = "";
            }else{
              this.state[n.name] = n.reg.test(newVal[n.name])?'success':'error';
            }
          })
        },
        deep:true
      }
    },
    methods:{
      sendSmsForReg:function(){
        let vm = this;
        if(this.state['username']!='success'){
          Toast("请输入正确手机号码！");
          return;
        }
        vm.smsCount = 60;
        this.$http.get("/wx/sendSmsForReg?phone="+this.data.username).then((resp)=>{
             if(resp.code == 0){
                   InterValObj = window.setInterval(()=>{
                  if(vm.smsCount>0){
                    vm.smsCount--
                  }else{
                    clearInterval(InterValObj);
                  }
                }, 1000);
             }else{
               vm.smsCount = 0;
               Toast(resp.msg);
             }
        })
      },
      register:function(){
        let vm = this;
        let attr = attrs.find(n=>{return vm.state[n.name]!='success'})
        if(attr){
           Toast(attr.name+"输入错误!");
           return;
        }
        this.$http.post("/wx/register",changeDataType(this.data)).then((resp)=>{
           if(resp.code == 0){
             Toast("注册成功,请登录！");
             vm.$router.push({path:"/login/login"})
           }else{
             Toast(resp.msg);
           }
        })
      }
    }
  }
</script>

<style scoped>
.padlr10{
  padding:10px;
}
  .mgtop10{
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/login/register.vue